import React, { useContext } from "react";
import {
  Caption,
  Card,
  Collapsible,
  ColorPicker,
  Layout,
  Stack,
  TextField,
  TextStyle,
  TextContainer,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const MenuTab = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { HEX, COLOR, MENU, DEFAULT_MENU_COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.menuColor.title")}
        description={cms("section.menuColor.description")}
      >
        <Card
          title={[
            cms("section.menuColor.title"),
            updatedAt && (
              <TextStyle variation="subdued">
                <Caption>{`${baseHelper.lastUpdateDate(updatedAt)}`}</Caption>
              </TextStyle>
            ),
          ]}
        >
          <Card.Section>
            <TextContainer>{cms("section.menuColor.subDescription")}</TextContainer>

            <br />
            <Stack>
              <Stack.Item fill>
                <TextField
                  label={cms("section.menuColor.label.hexCode")}
                  value={hex.menuHex}
                  onChange={(value) => handleChange(MENU, value, HEX)}
                  labelAction={
                    hex.menuHex !== DEFAULT_MENU_COLOR && {
                      content: cms("label.reset"),
                      onClick: () => resetDefault(MENU, DEFAULT_MENU_COLOR, HEX),
                    }
                  }
                  error={errorMessage && errorMessage.menu}
                />
                <br />
                <TextStyle>
                  <div
                    style={{
                      width: "120px",
                      height: "50px",
                      color: hex.menuHex,
                      textAlign: "center",
                      paddingTop: "13px",
                    }}
                  >
                    {cms("section.menuColor.label.sampleHeader")}
                  </div>
                </TextStyle>
              </Stack.Item>
              <Stack.Item>
                <ColorPicker onChange={(value) => handleChange(MENU, value, COLOR)} color={color.menuColor} />
              </Stack.Item>
            </Stack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withErrorBoundary(MenuTab);
